import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import WaterSourceTypeForm from '../Forms/WaterSourceTypeForm';

const AddEditWaterSourceTypeModal = ({
	dataWaterSourceType,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Tipo de Fuente de Agua
			</ModalHeader>

			<WaterSourceTypeForm
				dataWaterSourceType={dataWaterSourceType}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditWaterSourceTypeModal;
